<template lang="html">
	<div :class="inputClass" style="margin:0;padding:0;">
		<input type="text" :disabled="disabled" :class="inputClass" style="border:0;" :realtime="realtime" @keyup.down.stop.prevent="abajo()" @keyup.up.stop.self="arriba()" @keyup="teclaPulsada($event)" :placeholder="placeholder" v-model="cadena" ref="inp">
		<div v-if="resultados.length > 0" class="caja" :style="estiloCaja" ref="caja" id="caja-query">
			<table style="width: 100%; margin: 0;">
				<tbody>
					<tr v-for="(resultado, index) in resultados" ref="resultado">
						<td :class="getClase(resultado)" @click="seleccionar(resultado)" @mouseover="preseleccionado = resultado">
							<span v-if="resultado.icono" :class="resultado.icono" class="mr-2"></span>
							{{ resultado.texto }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
export default {
	name: 'input-query',
	props: ['input-class', 'url', 'realtime', 'placeholder', 'disabled', 'conservar'],
	data: function () {
		return {
			cadena: '',
			resultados: [],
			preseleccionado: null,
			preseleccionadoIndex: null,
			seleccionado: null,
			estiloCaja: {}
		}
	},
	mounted: function () {
		const inp = this.$refs.inp
		const top = inp.offsetTop + inp.offsetHeight
		const left = inp.offsetLeft
		const width = inp.offsetWidth

		this.estiloCaja = {
			top: top + 'px',
			left: left + 'px',
			width: width + 'px'
		}
	},

	methods: {

		calculaEstilo () {
			const inp = this.$refs.inp
			const top = inp.offsetTop + inp.offsetHeight
			const left = inp.offsetLeft
			const width = inp.offsetWidth

			this.estiloCaja = {
				top: top + 'px',
				left: left + 'px',
				width: width + 'px'
			}
		},
		preseleccionar (i) {
			this.preseleccionado = this.resultados[i]
			this.preseleccionadoIndex = i
			const el = this.$refs['resultado'][i]
			el.scrollIntoViewIfNeeded()
		},
		teclaPulsada (ev) {
			ev.stopPropagation()
			ev.preventDefault()
			this.calculaEstilo()
			if (ev.keyCode === 40 || ev.keyCode === 38) {
				return
			} else if (ev.keyCode === 27) {
				this.resultados = []
				this.cadena = ''
				this.preseleccionado = null
				this.preseleccionadoIndex = null
				return
			} else if (ev.keyCode === 13 && (this.preseleccionado !== null || this.resultados.length > 0)) {
				if (this.preseleccionado !== null) {
					this.seleccionar(this.preseleccionado)
				} else {
					this.seleccionar(this.resultados[0])
				}
				return
			}

			if (!this.cadena.trim()) {
				this.resultados = []
				return
			}
			this.preseleccionado = null
			this.preseleccionadoIndex = null
			if (this.realtime) {
				this.buscar()
			} else if (ev.keyCode === 13) {
				this.buscar()
			}
		},

		abajo () {
			if (!this.preseleccionado) {
				this.preseleccionar(0)
				return
			}

			const i = this.resultados.indexOf(this.preseleccionado)
			if (i === this.resultados.length - 1) {
				this.preseleccionar(0)
			} else {
				this.preseleccionar(i + 1)
			}
		},

		arriba () {
			if (!this.preseleccionado) {
				this.preseleccionar(this.resultados.length - 1)
				return
			}
			const i = this.resultados.indexOf(this.preseleccionado)

			if (i === 0) {
				this.preseleccionar(this.resultados.length - 1)
			} else {
				this.preseleccionar(i - 1)
			}
		},

		getClase (resultado) {
			if (resultado === this.preseleccionado) {
				return 'result active'
			} else {
				return 'result'
			}
		},

		buscar () {
			const amp = (this.url.match(/\?/)) ? '&' : '?'
			const datos = {
				q: this.cadena
			}
			this.$http.post(this.url + amp + 'q=' + this.cadena, datos)
				.then(res => {
					this.resultados = res.data.resultados
				})
				.catch(e => {
					console.error(e)
				})
		},

		seleccionar (valor) {
			this.$emit('selected', valor)
			this.seleccionado = valor
			this.resultados = []
			if (!this.conservar) {
				this.cadena = ''
			} else {
				this.cadena = valor.texto
			}
		},

		focus () {
			window.setTimeout(() => {
				this.$refs['inp'].focus()
			}, 100)
		}
	}
}
</script>

<style lang="css">
	.caja {
		position: absolute;
		display: block;
		border: 1px solid #e0e0e0;
		background-color: white;
		padding: 5px;
		margin: 0;
		padding: 0;
		max-height: 400px;
		overflow-y: auto;
	}
	#caja-query {
		z-index: 1000;
	}
	.result {
		cursor: pointer;
		padding: 5px;
		margin: 0;
	}

	.result.active {
		background-color: #337AB7;
		color: white;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/input-query/input-query-cmp.vue